import { InputText, Button } from "primereact";
import MultiLanguageEditor from "../MultiLanguageEditor";
import { useLanguages } from "../../hooks/use-languages";
import { useForm, Controller } from "react-hook-form";
import { getMultiLngInitValue, validateMultiLanguageEditor } from "../../util";
import { useToast } from "../../hooks/use-toast";
import { getCommonParam } from "../../config";
import { useEffect, useState } from "react";
import axios from "axios";
import ShowOrUploadImg from "../ShowOrUploadImg";

const Azienda = () => {
  const [azienda, setAzienda] = useState();
  const { languages } = useLanguages();
  const {
    control,
    handleSubmit,
    reset,
    setValue,
    formState: { isSubmitting, isDirty },
  } = useForm();
  const { toastRef } = useToast();

  const onSubmit = async (data) => {
    try {
      console.log(data);
      const commonParam = getCommonParam();
      const { apiUrl, axiosConfig, companyId } = commonParam;
      await axios.post(`${apiUrl}azienda/salva/${companyId}`, data, axiosConfig).then((res) => {
        toastRef.current.showToast("success", "Dati salvati correttamente", "");  
        getCompanyInfo().then((res) => {
          reset(res);
          setAzienda(res);
        })
      });
    } catch (error) {
      console.error(error);
      toastRef.current.showToast("error", "Errore nel salvataggio dei dati", "");
    }
  };

  const getCompanyInfo = async () => {
    try {
      const commonParam = getCommonParam();
      const { apiUrl, axiosConfig, companyId } = commonParam;
      const { data } = await axios.get(apiUrl + "azienda/" + companyId, axiosConfig);
      return data;
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    getCompanyInfo()
      .then((res) => {
       
        setAzienda(res);
        if (!!res) {
          reset(res);
        }
      })
      .catch((error) => console.error(error));
  }, []);

  return (
    <div className="flex w-full px-4">
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="text-600 font-medium text-600 text-xl mb-3">
          <span style={{ color: azienda && azienda.tipo === "FOOD" ? "green" : "navy" }}>
            Dati Identificativi Azienda
          </span>
        </div>

        <div className="surface-card p-2  border-round">
          <div className="grid formgrid p-fluid">
            <div className="surface-border border-top-1 opacity-50 mb-3 col-12"></div>
            <div className="field mb-1 col-12 md:col-6">
              <label htmlFor="ragionesociale" className="font-medium text-600">
                Ragione Sociale
              </label>
              <Controller
                name="ragionesociale"
                control={control}
                defaultValue=""
                render={({ field }) => <InputText {...field} className="w-full flex" type="text" />}
              />
            </div>
            <div className="field mb-1 col-12 md:col-6">
              <label htmlFor="sede" className="font-medium text-600">
                Sede Principale
              </label>
              <Controller
                name="sede"
                control={control}
                defaultValue=""
                render={({ field }) => <InputText {...field} className="w-full flex" type="text" />}
              />
            </div>
            <div className="field mb-1 col-12 md:col-6">
              <label htmlFor="partitaiva" className="font-medium text-600">
                Partita Iva
              </label>
              <Controller
                name="partitaiva"
                defaultValue=""
                control={control}
                rules={{ required: "Campo obbligatorio" }}
                render={({ field, fieldState }) => (
                  <>
                    <InputText {...field} className="w-full flex" type="text" />
                    {fieldState && fieldState?.error && (
                      <span className="text-xs font-bold text-red-500 ">{fieldState.error.message}</span>
                    )}
                  </>
                )}
              />
            </div>
            <div className="field mb-1 col-12 md:col-6">
              <label htmlFor="telefono" className="font-medium text-600">
                Telefono
              </label>
              <Controller
                name="telefono"
                defaultValue=""
                control={control}
                render={({ field }) => <InputText {...field} className="w-full flex" type="text" />}
              />
            </div>
            <div className="field mb-1 col-12 md:col-6">
              <label htmlFor="email" className="font-medium text-600">
                Email
              </label>
              <Controller
                name="email"
                defaultValue=""
                control={control}
                rules={{
                  required: "Campo obbligatorio",
                  pattern: {
                    value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                    message: "Indirizzo email non valido",
                  },
                }}
                render={({ field, fieldState }) => (
                  <>
                    <InputText {...field} className="w-full flex" type="email" />
                    {fieldState && fieldState?.error && (
                      <span className="text-xs font-bold text-red-500 ">{fieldState.error.message}</span>
                    )}
                  </>
                )}
              />
            </div>
            <div className="field mb-1 col-12 md:col-6">
              <label htmlFor="pec" className="font-medium text-600">
                Pec
              </label>
              <Controller
                name="pec"
                defaultValue=""
                control={control}
                render={({ field }) => (
                  <InputText {...field} value={field.value ?? ""} className="w-full flex" type="email" />
                )}
              />
            </div>
            <div className="field mb-1 col-12 md:col-6">
              <label htmlFor="sitoweb" className="font-medium text-600">
                Sito Web
              </label>
              <div className="p-inputgroup">
                <Controller
                  name="sitoweb"
                  control={control}
                  render={({ field }) => (
                    <InputText {...field} value={field.value ?? ""} className="w-full flex" type="text" />
                  )}
                />
              </div>
            </div>
            <div className="field mb-1 col-12 md:col-6" />
            <div className="field mb-1 col-12 md:col-6">
              <label htmlFor="facebook" className="font-medium text-600">
                facebook
              </label>
              <Controller
                name="facebook"
                control={control}
                defaultValue={""}
                render={({ field }) => (
                  <InputText {...field} value={field.value ?? ""} className="w-full flex" type="text" />
                )}
              />
            </div>
            <div className="field mb-1 col-12 md:col-6">
              <label htmlFor="instagram" className="font-medium text-600">
                instagram
              </label>
              <Controller
                name="instagram"
                control={control}
                defaultValue={""}
                render={({ field }) => (
                  <InputText {...field} value={field.value ?? ""} className="w-full flex" type="text" />
                )}
              />
            </div>
            <div className="field mb-1 col-12 md:col-6">
              <label htmlFor="ateco1" className="font-medium text-600">
                Codice Ateco Prevalente
              </label>
              <Controller
                name="ateco1"
                control={control}
                defaultValue={""}
                render={({ field }) => (
                  <InputText {...field} value={field.value ?? ""} className="w-full flex" type="text" />
                )}
              />
            </div>
            <div className="field mb-1 col-12 md:col-6">
              <label htmlFor="ateco2" className="font-medium text-600">
                Codice Ateco Secondario
              </label>
              <Controller
                name="ateco2"
                control={control}
                defaultValue={""}
                render={({ field }) => (
                  <InputText {...field} value={field.value ?? ""} className="w-full flex" type="text" />
                )}
              />
            </div>
            <div className="col-12 my-4">
              <ShowOrUploadImg
                hasImage={azienda && azienda.hasImage}
                aziendaid={azienda && azienda.id}
                itemId={azienda && azienda.id}
                label={"Logo Azienda"}
                isDirty={isDirty}
                operationType="U"
                table={"logo"}
              />
            </div>
            <div className="col-12">
              <Controller
                
                name="traduzione"
                control={control}
                rules={{ validate: (values) => validateMultiLanguageEditor(values, languages) }}
                render={({ field, fieldState }) => (
                  <MultiLanguageEditor
                    label={"Note aggiuntive"}
                    type="text-area"
                    languages={languages}
                    className={"px-2 py-2"}
                    content={getMultiLngInitValue("azienda", "note", languages, field.value)}
                    setValue={setValue}
                    fieldName={"traduzione"}
                    error={fieldState.error ?? undefined}
                  />
                )}
              />
            </div>
            <div className="surface-border border-top-1 opacity-50 mb-3 col-12"></div>
            <div className="col-12">
              <Button
                label="Salva"
                className="w-auto mt-3"
                type="submit"
                icon="pi pi-save"
                disabled={isSubmitting}
                loading={isSubmitting}
              />
            </div>
          </div>
        </div>
      </form>
    </div>
  );
};

export default Azienda;
